import { Form } from '@mairistem/composants';
import React from 'react';
import { toast } from 'react-toastify';
import { Combobox, Icon, Panel } from '@mairistem/finances-utils';
import { isEmpty } from 'lodash';
import { ASAP, ASAP_OPTIONS } from '../../../constants/mouvements/asapOptions';
import { createServiceDebit } from '../../../services/piecesComptables/servicesDebit';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const EditionAsapDematerialiseeComponent = ({
  data,
  handlePin,
  onChange,
  panel,
  setPanelOptions,
}: PanelComponentProps) => {
  const handleAddCodeService = async (e, { value }) => {
    try {
      const res = await createServiceDebit(
        {
          nom: value,
          code: value,
          engaOblig: false,
          defaut: isEmpty(data?.asapCodesService),
          identifiantTiers: data?.identifiantTiers,
        },
      );

      setPanelOptions((old) => ({
        ...old,
        asapCodesService: [...old.asapCodesService, {
          text: res?.code,
          value: res?.identifiant,
          key: res?.identifiant,
          'data-testid': `codesService${res?.code}`,
        }],
      }));
    } catch {
      toast.error("Impossible d'ajouter le code service");
    }
  };

  const handleChangeAsapEdition = (e, { name, value }) => {
    if (!data?.isTiersMulti) {
      onChange?.({
        [name]: value,
        ...(value !== ASAP.CHORUS_PRO && {
          asapNumeroEngagement: null,
          asapCodeService: null,
        }),
        ...((value === ASAP.CHORUS_PRO && isEmpty(data?.asapCodeService)) && {
          asapCodeService: 'FACTURE_PUBLIQUE',
        }),
      }, panel);
    }
  };

  const handleChange = (e, { name, value }) => onChange?.({ [name]: value }, panel);

  return (
    <Panel panel={panel} onPin={handlePin}>
      <Form>
        <Form.Group className="panelRow">
          <Form.Field
            control={Combobox}
            data-testid="editionAsapDematerialiseeEditionDropdown"
            key="asapEdition"
            label="Traitement à effectuer par les services de la DGFiP"
            // @ts-expect-error
            name="asapEdition"
            onChange={handleChangeAsapEdition}
            options={ASAP_OPTIONS}
            search
            selection
            value={data?.asapEdition}
            width={14}
          />
          <Form.Input
            circular
            className="panelButton"
            control={Icon}
            data-testid="editionAsapDematerialiseeEditionIcon"
            name="info circle"
            size="large"
            width={2}
          />
        </Form.Group>
        <Form.Field
          // @ts-expect-error
          additionLabel="Ajouter  "
          allowAdditions={!data?.isTiersMulti}
          control={Combobox}
          data-testid="editionAsapDematerialiseeCodeServiceDropdown"
          disabled={data?.asapEdition !== ASAP?.CHORUS_PRO}
          fluid
          key="asapCodeService"
          label="Service du débiteur"
          name="asapCodeService"
          onAddItem={handleAddCodeService}
          onChange={handleChange}
          options={data?.asapCodesService}
          placeholder={data?.asapCodeService}
          search
          selection
          value={data?.asapCodeService}
        />
        <Form.Input
          data-testid="editionAsapDematerialiseeasapNumeroEngagementInput"
          disabled={data?.asapEdition !== ASAP?.CHORUS_PRO}
          fluid
          key="asapNumeroEngagement"
          label="Numéro de l'engagement indiqué par le débiteur"
          name="asapNumeroEngagement"
          onChange={handleChange}
          value={data?.asapNumeroEngagement ?? ''}
        />
      </Form>
    </Panel>
  );
};

export default EditionAsapDematerialiseeComponent;
